"use client";

import type { LeadFormFieldChangeHandler } from "./form-types";

import { Link } from "@homeinstead/ui/components/Link";
import { useLocale } from "~www/components/LocaleProvider";
import { usePersistedCheckboxState } from "./use-persisted-checkbox-state";

interface SmsOptInFieldProps {
  onFieldChange?: LeadFormFieldChangeHandler;
}

export function SmsOptInField({ onFieldChange }: SmsOptInFieldProps) {
  const locale = useLocale();
  const privacyPolicyHref = `${locale.metadata.canonicalOrigin}/legal/privacy-policy`;
  const [checked, setChecked] = usePersistedCheckboxState(
    "consentTerms",
    onFieldChange,
  );

  return (
    <label className="flex cursor-pointer items-start gap-3 text-xs leading-relaxed">
      <input
        checked={checked}
        className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-new-beginnings-base"
        name="consentTerms"
        onChange={(e) => setChecked(e.target.checked)}
        type="checkbox"
        value="on"
      />
      <span>
        By checking this box, I agree to receive SMS text messages from Home
        Instead at the phone number provided. Message &amp; data rates may
        apply. Message frequency may vary based on service needs and SMS
        activity. Reply STOP to opt out of further messaging. For more details,
        including our SMS terms, please refer to our{" "}
        <Link
          className="text-xs underline hover:no-underline"
          href={privacyPolicyHref}
          rel="noopener noreferrer"
          size="inline"
          target="_blank"
          variant="plain"
        >
          Privacy Policy
        </Link>
        .
      </span>
    </label>
  );
}
